<template>
  <div class="row py-2" style="border-top: 1px solid gray">
    <div class="col-9">{{ meterData.bx_mac }}</div>
    <div class="col-3">
      <button class="btn btn-success btn-sm" data-toggle="modal" :data-target="`#editRegionMeterModal` + meterData.id">
        編輯
      </button>
      <div class="modal fade" :id="`editRegionMeterModal` + meterData.id" tabindex="-1" role="dialog">
        <div class="modal-dialog modal-dialog-centered" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">編輯 {{ meterData.bx_mac }}</h5>
            </div>
            <div class="modal-body">
              <edit-region-meter :meter-data="meterData" @update-circuits="updateCircuits"></edit-region-meter>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-success" data-dismiss="modal" @click="editRegionMeter()">
                確定
              </button>
            </div>
          </div>
        </div>
      </div>
      <button class="btn btn-danger btn-sm" data-toggle="modal" :data-target="`#deleteRegionMeterModal` + meterData.id">
        刪除
      </button>
      <div class="modal fade" :id="`deleteRegionMeterModal` + meterData.id" tabindex="-1" role="dialog">
        <div class="modal-dialog modal-dialog-centered" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">確認刪除 {{ meterData.bx_mac }}？</h5>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-secondary" data-dismiss="modal">取消</button>
              <button type="button" class="btn btn-danger"
                @click="deleteMeterFromRegion(meterData.region_id, meterData.bx_mac)" data-dismiss="modal">
                刪除
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import EditRegionMeter from './EditRegionMeter.vue';

export default {
  data() {
    return {
      base_url,
      circuits: '',
    }
  },
  methods: {
    deleteMeterFromRegion(region_id, mac) {
      axios.delete(base_url + `/api/bx`, {
        headers: { 'Content-Type': 'application/json' },
        data: { bx_mac: mac, region_id: region_id }
      }).then(response => {
        this.$emit('update-region')
      }).catch(error => { console.error('Error adding mac into region:', error.toJSON()); })
    },
    editRegionMeter() {
      const meter = this.$props.meterData;
      this.circuits = this.circuits.filter(function (circuit) {
        return circuit.channels.length !== 0;
      })
      axios.patch(base_url + "/api/bx/mac/" + meter.region_id, {
        "bx_mac": meter.bx_mac,
        "mac_alias": meter.mac_alias,
        "circuits": this.circuits
      }).then((response) => {
        this.circuits = '';
        this.$emit('update-region')
      }).catch(function (error) { console.error(error.toJSON()); });
    },
    updateCircuits(circuits) {
      this.circuits = circuits;
    }
  },
  components: { EditRegionMeter },
  props: ['meterData'],
}
</script>

<style>
#addLoopIntoChannel .card-body {
  flex-direction: row;
}
</style>
